const choices = [
  { id: 0, name: 'Gerente de loja' },
  { id: 1, name: 'Gerente de frente de caixa' },
  { id: 2, name: 'Frentista de caixa' },
];

export default choices;
